var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBaseActivePin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.108,
    height: 71.633,
    viewBox: "0 0 54.108 71.633",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_4421",
    x: 0,
    y: 0,
    width: 54.108,
    height: 71.633,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4814",
    "data-name": "Group 4814",
    transform: "translate(17632 14683.634)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(-17623 -14677.634)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 13.721,
    cy: 13.721,
    r: 13.721,
    transform: "translate(4.364 4.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4421-2",
    "data-name": "Path 4421",
    d: "M18.054,0A18.054,18.054,0,0,0,0,18.054c0,9.971,18.054,35.579,18.054,35.579S36.108,28.025,36.108,18.054A18.054,18.054,0,0,0,18.054,0m0,30.965A12.911,12.911,0,1,1,30.965,18.054,12.911,12.911,0,0,1,18.054,30.965",
    transform: "translate(9 6)",
    fill: "#ea4335"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "users-medical",
    transform: "translate(-17613.027 -14666.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4498",
    "data-name": "Path 4498",
    d: "M450.02,320a.405.405,0,0,0-.4.4v1.212H448.4a.405.405,0,0,0-.4.4v.808a.405.405,0,0,0,.4.4h1.212v1.212a.405.405,0,0,0,.4.4h.808a.405.405,0,0,0,.4-.4v-1.212h1.212a.405.405,0,0,0,.4-.4v-.808a.405.405,0,0,0-.4-.4h-1.212V320.4a.405.405,0,0,0-.4-.4Z",
    transform: "translate(-436.687 -311.919)",
    fill: "#888",
    opacity: 0.802
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4499",
    "data-name": "Path 4499",
    d: "M1.616,2.02a2.02,2.02,0,1,1,2.02,2.02,2.02,2.02,0,0,1-2.02-2.02Zm9.293,0a2.02,2.02,0,1,1,2.02,2.02,2.02,2.02,0,0,1-2.02-2.02ZM2.694,4.848H3.773A2.709,2.709,0,0,1,4.9,5.093a3.178,3.178,0,0,0-.048.563A3.233,3.233,0,0,0,5.944,8.081H.538A.54.54,0,0,1,0,7.543,2.7,2.7,0,0,1,2.694,4.848Zm7.525,3.232a3.224,3.224,0,0,0,1.093-2.424,3.458,3.458,0,0,0-.048-.563,2.67,2.67,0,0,1,1.126-.245h1.078a2.7,2.7,0,0,1,2.692,2.694.538.538,0,0,1-.538.538h-.338a1.215,1.215,0,0,0-1.144-.808h-.808a1.215,1.215,0,0,0-1.144.808h-1.97Zm.712,1.1a1.2,1.2,0,0,0-.427.922v.808a1.212,1.212,0,0,0,1.212,1.212h.4v.4a1.256,1.256,0,0,0,.068.4H3.906a.674.674,0,0,1-.674-.674A3.367,3.367,0,0,1,6.6,8.889H9.563A3.349,3.349,0,0,1,10.932,9.179ZM8.081,3.232A2.424,2.424,0,1,1,5.656,5.656,2.424,2.424,0,0,1,8.081,3.232Z",
    fill: "#ea4335"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBaseActivePin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BASE-active-pin.e464226fd365f7d9174c330adc812b68.svg";